import React from 'react';
import {
  FieldLabel,
  FormProps,
  getInputField,
  Row,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';

export const CodirectSection = (props: FormProps) => {
  const { isSubmitting } = props;
  return (
    <Section>
      <SectionTitle>Covideo for CDP</SectionTitle>
      <RowWrapper>
        <Row>
          <FieldLabel>ID</FieldLabel>
          {getInputField('codirectId', false, false, isSubmitting)}
        </Row>
      </RowWrapper>
    </Section>
  );
};
